
import React, { useEffect, useState } from "react";

import {
    Modal,
    Form,
    Input,
    Select,
    Button,
    Spin,
    message
} from "antd";

import {
    PlusOutlined,
    AppstoreAddOutlined
} from "@ant-design/icons";

import api from "../../api/api";


const { Option } = Select;


const AddClass = ({ open, handleClose, refreshClasses }) => {


    const [form] = Form.useForm();

    const [loading, setLoading] = useState(false);

    const [divisions, setDivisions] = useState([]);

    const token = localStorage.getItem("access");



    useEffect(() => {

        if(open){

            fetchDivisions();

        }

    }, [open]);




    const fetchDivisions = async () => {

        try {

            const response = await api.get(
                "/api/users/divisions/",
                {
                    headers:{
                        Authorization:`Bearer ${token}`
                    }
                }
            );


            setDivisions(response.data);


        } catch(error){

            console.log(error);

            message.error(
                "Failed to load divisions"
            );

        }

    };





    const handleSubmit = async(values)=>{


        setLoading(true);


        try{


            await api.post(

                "/api/users/grade-classes/",

                {
                    name:values.name,
                    division_id:values.division_id
                },

                {
                    headers:{
                        Authorization:`Bearer ${token}`
                    }
                }

            );



            message.success(
                "Class added successfully"
            );


            form.resetFields();


            handleClose();


            if(refreshClasses){

                refreshClasses();

            }



        }catch(error){


            console.log(error.response?.data);


            message.error(
                "Failed to add class"
            );


        }finally{


            setLoading(false);


        }


    };





    return (

        <Modal

            open={open}

            onCancel={handleClose}

            footer={null}

            centered

            width={450}

            title={

                <div
                    style={{
                        display:"flex",
                        alignItems:"center",
                        gap:10
                    }}
                >

                    <AppstoreAddOutlined
                        style={{
                            fontSize:22
                        }}
                    />

                    Add New Program or Class Name

                </div>

            }

        >



            <Form

                form={form}

                layout="vertical"

                onFinish={handleSubmit}

            >



                <Form.Item

                    label="Class or Program Name"

                    name="name"

                    rules={[
                        {
                            required:true,
                            message:"Please enter class or program name"
                        }
                    ]}

                >

                    <Input

                        size="large"

                        placeholder=" EX. Bachelor of Leadership & Management Cohort 2026"

                    />

                </Form.Item>





                <Form.Item

                    label="Select Department"

                    name="division_id"

                    rules={[
                        {
                            required:true,
                            message:"Please select department"
                        }
                    ]}

                >


                    <Select

                        size="large"

                        placeholder="Choose department"

                        showSearch

                        optionFilterProp="children"

                    >

                        {

                            divisions.map((division)=>(

                                <Option

                                    key={division.id}

                                    value={division.id}

                                >

                                    {division.name}

                                </Option>

                            ))

                        }


                    </Select>


                </Form.Item>




                <Button

                    type="primary"

                    htmlType="submit"

                    size="large"

                    block

                    icon={
                        loading
                        ?
                        <Spin size="small"/>
                        :
                        <PlusOutlined/>
                    }

                    disabled={loading}

                >

                    {
                        loading
                        ?
                        "Saving..."
                        :
                        "Add Class"
                    }


                </Button>



            </Form>


        </Modal>

    );

};


export default AddClass;